import React from 'react'
import { Rating } from '@mui/material'

import { accentColors, lightTokens, typography } from '~tokens/internal'
import { InteractionRatingType } from '~types'

import './ScoreRating.scss'

const RATING_VALUES = InteractionRatingType.options.map((option) => option.value)
const MAX_SCORE = Math.max(...RATING_VALUES)

const getScoreColor = (score: number, maxScore: number): string => {
  const ratio = score / maxScore
  if (ratio <= 0.2) return lightTokens.error.main
  if (ratio <= 0.4) return lightTokens.warning.main
  if (ratio <= 0.6) return accentColors.amber.main
  if (ratio <= 0.8) return accentColors.teal.main
  return lightTokens.success.main
}

const ScoreDotFilled: React.FC = () => (
  <svg
    width={typography.fontSizePx.md}
    height={typography.fontSizePx.md}
    viewBox='0 0 18 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M9 1.5C4.8525 1.5 1.5 4.8525 1.5 9C1.5 13.1475 4.8525 16.5 9 16.5C13.1475 16.5 16.5 13.1475 16.5 9C16.5 4.8525 13.1475 1.5 9 1.5Z'
      fill='currentColor'
    />
  </svg>
)

const ScoreDotEmpty: React.FC = () => (
  <svg
    width={typography.fontSizePx.md}
    height={typography.fontSizePx.md}
    viewBox='0 0 18 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M9 1.5C4.86 1.5 1.5 4.86 1.5 9C1.5 13.14 4.86 16.5 9 16.5C13.14 16.5 16.5 13.14 16.5 9C16.5 4.86 13.14 1.5 9 1.5ZM9 15C5.685 15 3 12.315 3 9C3 5.685 5.685 3 9 3C12.315 3 15 5.685 15 9C15 12.315 12.315 15 9 15Z'
      fill='currentColor'
    />
  </svg>
)

interface ScoreRatingProps {
  rating: number
  className?: string
}

export const ScoreRating: React.FC<ScoreRatingProps> = ({ rating, className }) => (
  <Rating
    value={rating}
    max={MAX_SCORE}
    readOnly
    size='small'
    icon={<ScoreDotFilled />}
    emptyIcon={<ScoreDotEmpty />}
    className={`internal-score-rating ${className || ''}`}
    style={
      {
        '--score-color': getScoreColor(rating, MAX_SCORE),
      } as React.CSSProperties
    }
  />
)
